import Lottie from "lottie-react";
import loadingAnimation from "../loader/Loader1.json";

function LoadingAnimation() {
  return (
    <div style={{
      position: 'fixed',  // important: fixed positioning
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent', // no background
      zIndex: 9999 // make sure it stays on top if needed
    }}>
      <div style={{ width: 150, height: 150 }}>
        <Lottie 
          animationData={loadingAnimation} 
          loop 
          style={{ background: 'transparent' ,filter: 'hue-rotate(210deg) saturate(6)' }} 
        />
      </div>
    </div>
  );
}

export default LoadingAnimation;
